export enum ClimateActionTypes {
  Emissions,
  Mitigations,
  Summary,
}
